import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// Component
import TooltipDialogFixed from 'components/TooltipDialogFixed';
import Checkbox from 'components/Checkbox';

const AccountManagementTable = (props) => {
  const {
    changeModalStatus,
    tableRef,
    stickyStyle,
    tableHeader,
    currentAccountList,
    selectedPage,
    selectedPageLimit,
    checkedAllState,
    toggleCheckedAll,
    toggleChecked,
    selectAccountCallback
  } = props;

  const { t } = useTranslation();

  const showManagedScope = (account) => {
    if (account.managedScope.length === 0) {
      return '-';
    } else {
      let html = '';

      for (const name of account.managedScope) {
        html += `<div class='pb-1'>${name}</div>`;
      }

      return (
        <TooltipDialogFixed
          className="ms-1 me-1"
          hideIcon={true}
          placement="right"
          tooltipsTitle={account.managedScope.length}
          title={html}
        />
      );
    }
  }

  return (
    <>
      <Table responsive striped hover className="table-container" ref={tableRef}>
        <thead style={stickyStyle}>
          <tr>
            <th>
              <Checkbox
                id="rl-th-cb1"
                type='checkbox'
                checked={checkedAllState()}
                onChange={toggleCheckedAll}
              />
            </th>
            <th>#</th>
            {tableHeader()}
          </tr>
        </thead>
        <tbody>
          {currentAccountList && currentAccountList.map((account, index) => {
            return (
              <tr key={index}>
                <td>
                  <Checkbox
                    id={`rl-cb${index}`}
                    type='checkbox'
                    checked={account.checked === true}
                    onChange={e => toggleChecked(index)}
                  />
                </td>
                <td>{((selectedPage - 1) * selectedPageLimit) + index + 1}</td>
                <td>
                  <a href="#/" onClick={() => {
                    selectAccountCallback(account);
                    changeModalStatus('inviteAndEdit', true)
                  }}>{account.name}</a>
                </td>
                <td>{account.email}</td>
                <td>{`${t(account.accessLevelLabel)}(${account.accessLevelOwner})`}</td>
                <td>{`${t(account.accessPrivilegeLabel)}`}</td>
                <td>{showManagedScope(account)}</td>
                <td>
                  {account.status && t(account.statusLabel)}
                  {!account.status && (
                    <span className='table-unverified-link' onClick={() => {
                      selectAccountCallback(account);
                      changeModalStatus('resendVerificationEmail', true);
                    }}>
                      {t('d5ca088299')}
                    </span>
                  )}
                </td>
                <td>{account.lastAccessTime}</td>
              </tr>
            )
          })}
          {currentAccountList.length === 0 && (
            <tr>
              <td colSpan="9" className="no-data">
                {t('ad01242a61')}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}

export default AccountManagementTable;